// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "hash": "5db8cd3fdf4afe2b729f74fcbacc6832fc01fb23"
};
/* tslint:enable */
